// The data-layer side of a completed signup (mayainsights/mayainsights#1819, #1820). In
// GTM-TNS3FN5, `identify` fires HubSpot - Identify and Intercom; `sign_up_completed` fires
// GA4 - Events, Google Ads, Reddit; user_params.userId becomes the GA4 user_id.
import TagManager from 'react-gtm-module'
import { getSignupAttribution } from './signupAttribution'

export type SignupMethod = 'email' | 'google' | 'microsoft'

export const trackSignupCompleted = (user: { id: number | string; email?: string }, method: SignupMethod) => {
  const a = getSignupAttribution()
  const userParams = { userId: user.id, userEmail: user.email }
  TagManager.dataLayer({ dataLayer: { event: 'identify', user_params: userParams } })
  TagManager.dataLayer({
    dataLayer: {
      event: 'sign_up_completed',
      is_custom_track: true,
      user_id: user.id,
      method,
      intent: a.intent === 'shopify' || a.shop ? 'shopify' : 'general',
      shop: a.shop || undefined,
      lead_source: a.lead_source || 'direct',
      user_params: userParams,
    },
  })
  // HubSpot identify is a GTM tag ("HubSpot - Identify", trigger cE - identify) in
  // GTM-TNS3FN5, so the identify push above already ties the session to the contact.
}
